export default __webpack_public_path__ + "static/residential-land-black-logo-42ef0dc463f1ef3e2bb7ca70c625bc3f.png";